var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.menu},[_vm._l((_vm.list),function(ref){
var _obj;

var status = ref.status;
var name = ref.name;
var num = ref.num;return _c('div',{key:name,class:( _obj = {}, _obj[_vm.$style.chosen] = _vm.currId === status, _obj ),on:{"click":function($event){return _vm.handleClick(status)}}},[_vm._v("\n            "+_vm._s(name)+"\n            ")])}),_vm._v(" "),_c('span',[_vm._v("　|　")]),_vm._v(" "),_vm._l((_vm.type),function(item){
var _obj;
return _c('div',{key:item.name,class:( _obj = {}, _obj[_vm.$style.chosen] = _vm.curId == item.referer, _obj ),on:{"click":function($event){return _vm.handleClicks(item.referer)}}},[_vm._v("\n            "+_vm._s(item.name)+"\n        ")])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606f3d6b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList/Header.vue
// module id = null
// module chunks = 